import { AxiosResponse } from "axios";
import BaseDAO from "../BaseDAO";
import LogUtil, { LogRequestTipo } from "../../util/LogUtil";

class ObaBaseDAO extends BaseDAO {
  protected basePath: string = "https://mobile.redeoba.com.br/api";

  protected getBasePath(): string {
    return this.basePath;
  }

  private config: any = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
    auth: {
      username: "mobileapi",
      password: "1gFgowFqY3ZiNl",
    },
  };

  public get(key:string, url: string): Promise<AxiosResponse<any>> {
    LogUtil.logRequest(LogRequestTipo.GET, key, url, null);
    return super.get(key, url, this.config);
  }

  public post(key: string, url: string, body: any): Promise<AxiosResponse<any>> {
    LogUtil.logRequest(LogRequestTipo.POST, key, url, { body, config: this.config });
    return super.post(url, body, this.config);
  }
}

export default ObaBaseDAO;